import * as React from "react";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

interface Option {
  label: string;
  value: string;
}

interface CommonDropDownProps {
  label?: string;
  placeholder?: string;
  options: Option[]; // 🟢 Array of { label, value }
  value: string; // Only the selected value (i.e., value: "6839af..." )
  onChange: (value: string) => void;
  width?: number | string;
  height?: number | string;
  margin?: number | string;
  required?: boolean;
  error?: boolean; // ✅ Add this
  helperText?: string;
  menuWidth?: number | string; // ✅ new prop
}

const CommonDropDown: React.FC<CommonDropDownProps> = ({
  label,
  placeholder = "Select",
  options,
  value,
  onChange,
  width,
  height,
  margin,
  required,
  error,
  helperText,
  menuWidth, // ✅ new prop
}) => {
  const theme = useTheme();

  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value);
  };

  return (
    <FormControl
      sx={{ m: margin ?? 1, width: width || 300, height:"100%" ,justifyContent:'space-between'}}
    >
      {label && (
        <label
          style={{
            fontSize: "0.875rem",
            color: "#1e293b", // Tailwind's slate-800
            marginBottom: "4px",
            display: "block",
          }}
        >
          {label}
          {required && <span className="text-red-500">*</span>}
        </label>
      )}
      <Select
        displayEmpty
        fullWidth
        value={value}
        onChange={handleChange}
        input={<OutlinedInput />}
        IconComponent={KeyboardArrowDownIcon}
        renderValue={(selected) => {
          const selectedOption = options.find((opt) => opt.value === selected);
          return selectedOption ? selectedOption.label : <em>{placeholder}</em>;
        }}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: label !== "CategoryList" ? 38 * 4.5 + 8 : 38 * 4.5 + 18,
              width: menuWidth ?? (label === "Recent Enquiries" || label === "Monthly Profit" || label === "Profit Trend Chart" || label === "Revenue Pie Type" || label === "Revenue Line Type" ? 120 : 250),
            },
          },
        }}
        inputProps={{ "aria-label": "Without label" }}
        sx={{ fontSize: "0.875rem", height: height }}
      >
        <MenuItem disabled value="">
          <em>{placeholder}</em>
        </MenuItem>
        {options.map((opt: Option, idx: number) => (
          <MenuItem key={idx} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
      {error && helperText && (
        <span className="text-xs text-red-700 mt-1">{helperText}</span>
      )}
    </FormControl>
  );
};

export default CommonDropDown;
